export const capitalizeFirstLetter = (str: string | undefined): string => typeof str === 'string' ? str?.charAt(0)?.toUpperCase() + str?.slice(1) : ''
